import React, { useState } from "react";
import { IoChevronDownOutline, IoChevronForwardOutline, IoRemoveSharp } from "react-icons/io5";
import { NavLink, useLocation } from "react-router-dom";

const SidebarSubMenu = ({ route }) => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const handleSubMenuToggle = () => {
    setOpen(!open);
  };

  return (
    <>
      <button
        onClick={handleSubMenuToggle}
        className="flex items-center w-full px-4 py-2 text-white hover:text-emerald-600 focus:outline-none"
      >
        <div className="flex items-center">
          <span className="mt-1">
            {open ? <IoChevronDownOutline /> : <IoChevronForwardOutline />}
          </span>
        </div>
        <span className="ml-3">{route.name}</span>
      </button>
      {open && (
        <ul className="pl-8">
          {route.routes.map((child, i) => (
            <li key={i} className={`py-2 `}>
              {child?.outside ? (
                <a
                  href={child.path}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`flex items-center text-sm text-white hover:text-emerald-600`}
                >
                  <IoRemoveSharp className="mr-2" />
                  {child.name}
                </a>
              ) : (
                <NavLink
                  to={child.path}
                  className={({ isActive }) =>
                    `flex items-center${isActive ? 'bg-slate-500' : null} text-sm ${
                      isActive ? "text-emerald-600" : "text-white hover:text-emerald-600"
                    }`
                  }
                >
                  <span>{child.name}</span>
                </NavLink>
              )}
            </li>
          ))}
        </ul>
      )}
    </>
  );
};

export default SidebarSubMenu;
